import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SmileMark } from "../brand/Brand";

/**
 * Full-screen entry splash. Shows the standalone ":-D" symbol (not the full
 * wordmark) + an "Entrer" button that reveals the site.
 * Exit is CSS-driven (translateY) then self-unmounts via onEnter, so it does
 * not depend on framer-motion AnimatePresence exit callbacks.
 */
export default function IntroSplash({ onEnter }) {
  const [leaving, setLeaving] = useState(false);

  const handleEnter = () => {
    setLeaving(true);
    window.setTimeout(() => onEnter(), 800);
  };

  return (
    <div
      data-testid="intro-splash"
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center overflow-hidden grain transition-transform duration-[800ms] ease-[cubic-bezier(0.76,0,0.24,1)] ${
        leaving ? "-translate-y-full" : "translate-y-0"
      }`}
      style={{ background: "linear-gradient(180deg, #ED1C24 0%, #ED1C24 55%, #C9151C 100%)" }}
    >
      {/* faint oversized watermark */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, rotate: -6 }}
        animate={{ opacity: 0.1, scale: 1, rotate: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        className="pointer-events-none absolute -bottom-24 -left-24"
      >
        <SmileMark color="#FFFFFF" size={560} />
      </motion.div>

      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
        >
          <SmileMark color="#FFFFFF" size={200} />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-8 font-display italic text-2xl md:text-3xl text-white"
        >
          « Le quartier me connaît. »
        </motion.p>

        <button
          onClick={handleEnter}
          data-testid="intro-enter-btn"
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-white px-10 py-4 font-display font-semibold text-lg text-diallo-red shadow-xl shadow-black/10 transition-transform hover:scale-[1.04] active:scale-95"
        >
          Entrer
          <ArrowRight size={22} strokeWidth={2.4} />
        </button>
      </div>
    </div>
  );
}
